import { render, staticRenderFns } from "./RegisterController.vue?vue&type=template&id=051aebe4&scoped=true"
import script from "./RegisterController.vue?vue&type=script&lang=js"
export * from "./RegisterController.vue?vue&type=script&lang=js"
import style0 from "./RegisterController.vue?vue&type=style&index=0&id=051aebe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051aebe4",
  null
  
)

export default component.exports